/* PTB v19 — targeted English copy fixes (complements ptb-i18n-v17.js).
   Covers: product-page shipping/care copy with emoji prefixes, hero aria-label, image alt texts,
   one-size legend, selected-photo labels, and the French texts of the third-party discount popup.
   No inventory, variant, swatch, price, cart or shipping logic changes. */
(function () {
  'use strict';

  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('en') !== 0) return;

  var EXACT = {
    'Nouvelles entrées': 'New arrivals',
    'Fraîchement arrivés': 'Just landed',
    'Nouveautés': 'New arrivals',
    "Livraison offerte à partir de 80€ d'achat": 'Free shipping from €80',
    '✓ Livraison offerte débloquée avec ton code : FREESHIP': '✓ Free shipping unlocked with your code: FREESHIP',
    '✓ Livraison offerte débloquée avec ton code: FREESHIP': '✓ Free shipping unlocked with your code: FREESHIP',
    'Lavage à 30°, séchage à l’air libre et repassage sur l’envers.': 'Wash at 30°C, air dry and iron inside out.',
    "Lavage à 30°, séchage à l'air libre et repassage sur l'envers.": 'Wash at 30°C, air dry and iron inside out.',
    'Le code de réduction sera appliqué automatiquement au moment du paiement.': 'The discount code will be applied automatically at checkout.',
    'Code de réduction :': 'Discount code:',
    'Commencer mes achats': 'Start shopping'
  };

  var PHRASES = [
    [/Livraison offerte à partir de 80€ d'achat/g, 'Free shipping from €80'],
    [/Livraison offerte débloquée avec ton code\s*:\s*FREESHIP/g, 'Free shipping unlocked with your code: FREESHIP'],
    [/Nouvelles entrées/g, 'New arrivals'],
    [/Livraison mondiale — offerte dès /g, 'Worldwide shipping — free from '],
    [/PTB — Porte ton bled, fier de ses racines/g, 'PTB — Porte ton bled, proud of your roots'],
    [/^TAILLE : /, 'SIZE: '],
    [/couleur sélectionnée/g, 'selected color'],
    [/variante sélectionnée/g, 'selected variant'],
    [/^Photo du produit/, 'Product photo'],
    [/ blanc$/, ' white']
  ];

  function translateString(input) {
    if (typeof input !== 'string' || !input) return input;
    var leading = input.match(/^\s*/)[0];
    var trailing = input.match(/\s*$/)[0];
    var core = input.trim();
    if (!core) return input;
    if (Object.prototype.hasOwnProperty.call(EXACT, core)) return leading + EXACT[core] + trailing;

    var out = core;
    PHRASES.forEach(function (pair) { out = out.replace(pair[0], pair[1]); });
    return leading + out + trailing;
  }

  function shouldSkip(node) {
    var parent = node && node.parentElement;
    return !parent || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|TEMPLATE)$/.test(parent.tagName);
  }

  function translateTextNode(node) {
    if (!node || node.nodeType !== 3 || shouldSkip(node)) return;
    var translated = translateString(node.nodeValue);
    if (translated !== node.nodeValue) node.nodeValue = translated;
  }

  var ATTRS = ['alt', 'aria-label', 'title'];
  function translateElement(el) {
    if (!el || el.nodeType !== 1) return;
    ATTRS.forEach(function (attr) {
      if (!el.hasAttribute(attr)) return;
      var current = el.getAttribute(attr);
      var translated = translateString(current);
      if (translated !== current) el.setAttribute(attr, translated);
    });
  }

  function translateTree(root) {
    if (!root) return;
    if (root.nodeType === 1) translateElement(root);
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeType === 3) translateTextNode(node);
      else translateElement(node);
    }
  }

  translateTree(document.body);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData') translateTextNode(mutation.target);
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 3) translateTextNode(node);
        else if (node.nodeType === 1) translateTree(node);
      });
      if (mutation.type === 'attributes') translateElement(mutation.target);
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ATTRS
  });
})();